module.exports = __webpack_public_path__ + "static/media/frustration_c.c80c1736.svg";